import { useAppSelector } from 'hooks/redux';
import { isReadOnlyAccess } from 'helpers/functions/workspaceHelpers';
import { selectActiveUser } from 'store/userState/selectors';

export const useWorkspaceReadOnly = (): boolean => {
    const { workspaceId, workspaces } = useAppSelector(state => state.workspaceSlice);
    const user = useAppSelector(selectActiveUser);

    return isReadOnlyAccess(workspaces.find(ws => ws.id === workspaceId) || null, user?.id);
};
